export default __webpack_public_path__ + "static/media/icn-megaphone.6de1a979.svg";